const SvgIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    fill="none"
    viewBox="0 0 24 24"
  >
    <path
      fill="#ACADAE"
      d="M6 19.5c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2v-10c0-1.1-.9-2-2-2H8c-1.1 0-2 .9-2 2zm12-15h-2.5l-.71-.71c-.18-.18-.44-.29-.7-.29H9.91c-.26 0-.52.11-.7.29l-.71.71H6c-.55 0-1 .45-1 1s.45 1 1 1h12c.55 0 1-.45 1-1s-.45-1-1-1"
    ></path>
  </svg>
);

export default SvgIcon;
